export const ISSUE_SEVERITIES = {
  MISSING: 'missing',
  CHANGED: 'changed'
} as const

export type IssueSeverity = (typeof ISSUE_SEVERITIES)[keyof typeof ISSUE_SEVERITIES]
